// Author Liang Gang Qiang
// Date 2022-01-05 09:01:14

class SithMesInventoryOutdoorProductDetail {
constructor({
        id = null,
        outdoorId = '',
        materialCode = '',
        materialName = '',
        amount = '',
        unit = '',
        length = '',
        width = '',
        height = '',
        weight = '',
        area = '',
        category = '',
        borrower = '',
        borrowStatus = '',
        returnDate = '',
        remark = ''}
= {}) {
    this.id = id;
    this.outdoorId = outdoorId;
    this.materialCode = materialCode;
    this.materialName = materialName;
    this.amount = amount;
    this.unit = unit;
    this.length = length;
    this.width = width;
    this.height = height;
    this.weight = weight;
    this.area = area;
    this.category = category;
    this.borrower = borrower;
    this.borrowStatus = borrowStatus;
    this.returnDate = returnDate;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesInventoryOutdoorProductDetail();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'outdoorCode',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.grid.outdoorCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'materialCode',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.grid.materialCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'materialName',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.grid.materialName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'amount',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.grid.amount',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'unit',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.grid.unit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'length',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.grid.length',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'width',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.grid.width',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'height',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.grid.height',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'weight',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.grid.weight',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'area',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.grid.area',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'category',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.grid.category',
        sortable: true,
        form: {
        type: 'entitySelect'
            ,entity: 'sithMesInventoryOutdoorProductCategory'
        }
        },
        {
        key: 'borrowerName',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.grid.borrowerName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'borrowStatus',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.grid.borrowStatus',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '2', text: '已借出' },
                            { value: '3', text: '已归还' }
            ]
        }
        },
        {
        key: 'returnDate',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.grid.returnDate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'itemType',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.grid.itemType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '出场物品' },
                            { value: '2', text: '返回物品' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    outdoorIdFilter : '',
    materialCodeFilter : '',
    materialNameFilter : '',
    amountFilter : '',
    unitFilter : '',
    lengthFilter : '',
    widthFilter : '',
    heightFilter : '',
    weightFilter : '',
    areaFilter : '',
    categoryFilter : '',
    borrowerFilter : '',
    borrowStatusFilter : '',
    returnDateRteFilter : '',
    returnDateLteFilter : '',
    itemTypeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'outdoorIdFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.filter.outdoorId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesInventoryOutdoorProcess'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'materialCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.filter.materialCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'materialNameFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.filter.materialName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'amountFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.filter.amount',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'unitFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.filter.unit',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'lengthFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.filter.length',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'widthFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.filter.width',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'heightFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.filter.height',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'weightFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.filter.weight',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'areaFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.filter.area',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'categoryFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.filter.category',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'sithMesInventoryOutdoorProductCategory'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'borrowerFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.filter.borrower',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'borrowStatusFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.filter.borrowStatus',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '2', text: '已借出' },
                { value: '3', text: '已归还' }
            ]
        }
        },
        {
        key: 'returnDateRteFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.filter.returnDateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'returnDateLteFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.filter.returnDateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'itemTypeFilter',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.filter.itemType',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '出场物品' },
                { value: '2', text: '返回物品' }
            ]
        }
        }
];


    const entityFormConfigs = [
        {
        key: 'outdoorId',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.entity.outdoorId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesInventoryOutdoorProcess'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'materialCode',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.entity.materialCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'materialName',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.entity.materialName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'amount',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.entity.amount',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'unit',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.entity.unit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'length',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.entity.length',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'width',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.entity.width',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'height',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.entity.height',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'weight',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.entity.weight',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'area',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.entity.area',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'category',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.entity.category',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'sithMesInventoryOutdoorProductCategory'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'borrower',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.entity.borrower',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryOutdoorProductDetail.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesInventoryOutdoorProductDetail, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
